import { MenuItem } from "@mui/material";
import { GridCsvExportMenuItem, gridFilteredSortedRowIdsSelector, gridVisibleColumnFieldsSelector } from "@mui/x-data-grid";
import { GridToolbarExportContainer } from "@mui/x-data-grid";
import { useGridApiContext } from "@mui/x-data-grid-pro";
import { utils, writeFile } from "xlsx";

function ExcelExportMenuItem(props) {
  const apiRef = useGridApiContext();

  const { hideMenu } = props;

  function getExcelData(apiRef) {
    // Select rows and columns
    const filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef);
    const visibleColumnsField = gridVisibleColumnFieldsSelector(apiRef);

    // Format the data. Here we only keep the value
    const data = filteredSortedRowIds.map((id) => {
      const row = {};
      visibleColumnsField.forEach((field) => {
        row[field] = apiRef.current.getCellParams(id, field).value;
      });
      return row;
    });

    return data;
  }


  function handleExport(apiRef) {
    const data = getExcelData(apiRef);
    console.log({ data });
    // const rows = data.map((row) => {
    //   const mRow = {};
    //   for (const key of config.keys) {
    //     mRow[key] = row[key];
    //   }
    //   return mRow;
    // });

    const worksheet = utils.json_to_sheet(data);
    // utils.sheet_add_aoa(worksheet, [[...config.columnNames]], {
    //   origin: 'A1',
    // });

    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Data Sheet");
    writeFile(workbook, "Data.xlsx", { compression: true });
  }


  return (
    <MenuItem
      onClick={() => {
        console.log({ apiRef });
        handleExport(apiRef);
        // Hide the export menu after the export
        hideMenu?.();
      }}
    >
      Download as Excel
    </MenuItem>
  );
}

const csvOptions = { delimiter: ';' };

export default function CustomExportButton(props) {
  return (
    <GridToolbarExportContainer {...props}>
      <GridCsvExportMenuItem options={csvOptions} />
      <ExcelExportMenuItem />
    </GridToolbarExportContainer>
  );
}